// 业务机会联系人架构图
import axios from '@/config/httpConfig'

// 获取业务机会联系人架构图
export function display(data) {
    return axios.post('/contactHierarchy/display', data)
}